<template>
    <navbar position="fixed"
            :transparent="transparent"
            :color-on-scroll="colorOnScroll"
            menu-classes="ml-auto">
        <template slot-scope="{toggle, isToggled}">
                <router-link class="navbar-brand" to="/">
                    <img src='img/GLOGO512.png' style="width:25px;" alt="GAMS+"/>
                    <div>GAMS+ Monitoring</div>
                </router-link>
        </template>
        <template slot="navbar-menu">
            <li class="nav-item" v-if="$route.query.admin == 'ETCa'">
                <nav-link to="/article/add" class="nav-link btn-danger" style="color:white;">
                    <p>Add Article</p>
                </nav-link>
            </li>
        </template>
    </navbar>
</template>

<script>
  import { NavbarToggleButton, Navbar, NavLink } from '@/components';
  export default {
    name: 'main-navbar',
    props: {
      transparent: Boolean,
      colorOnScroll: Number,
    },
    components: {
      Navbar,
      NavbarToggleButton,
      NavLink
    }
  }
</script>

<style scoped>
.navbar-brand div{
    float:right;
    padding-left:10px;
    padding-top: 1px;
}
@media screen and (max-width: 500px){
    
    .navbar-brand div{
        float: right;
        padding-left: 10px;
        width: 100px;
        white-space: normal;
        line-height: 1.1;
    }
}
@media screen and (max-width: 420px){
    .navbar-brand div{
        float:right;
        padding-left: 0px;
            width: 100px;
    font-size: .8571em;
    padding-top: 4px;
    line-height: 1.1em;
    }
    
}
</style>
